#import "./SageGiftAccountDifferenceFields.graphql"

query GetSageGiftAccount($id: ID!) {
  sageGiftAccount(id: $id) {
    id
    name
    lastSageSyncDate
    sageId
    sageName
    status
    type
    syncTransactions
    sageClass
    sageCurrency
    sageDepartment
    sageLocation
    openDifferenceCount
    differences {
      ...SageGiftAccountDifferenceFields
    }
    fundAccount {
      id
      currency
      sageCode
      fund {
        id
        name
        legalEntity {
          id
          name
        }
      }
    }
  }
}
